import { Stack, useTheme } from "@fluentui/react";
import React from "react";
import { getServiceTextContainerStyle } from "./ServiceTextContainer.styles";
export const ServiceTextContainer = ({ children, marginBottom = 0 }) => {
    const theme = useTheme();
    return (React.createElement(Stack, { horizontal: true, verticalAlign: "center", styles: getServiceTextContainerStyle(theme, marginBottom), tokens: {
            childrenGap: 9,
            padding: 12,
        } }, children));
};
